/**
 * Decorator factory to call a callback after the decorated method.
 *
 * **Usage:**
 *  - date-picker: `@AfterMethod((self) => self.updatePendingQueryContextFromUIModels())`
 *  - table-dashboard-item: `@AfterMethod((self) => self.setTableHeight())`
 */

export function AfterMethod(callback: (self: any) => void) {
    return function (
        target: any,
        propertyKey: string,
        descriptor: PropertyDescriptor
    ) {
        const originalMethod = descriptor.value;
        descriptor.value = function (...args: any[]) {
            const result = originalMethod.apply(this, args);
            callback(this);
            return result;
        };
        return descriptor;
    };
}
